import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _Errors;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { jsx } from '@instructure/emotion';
import { toErrors } from '../../../../../util/instUIMessages';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { Text } from '@instructure/ui-text';
import { View } from '@instructure/ui-view';
import { enhanceErrorMessages, withStyleOverrides } from '@instructure/quiz-common';
import { Alert } from '@instructure/ui-alerts';
var Errors = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_Errors = /*#__PURE__*/function (_Component) {
  function Errors() {
    _classCallCheck(this, Errors);
    return _callSuper(this, Errors, arguments);
  }
  _inherits(Errors, _Component);
  return _createClass(Errors, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.makeStyles();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.makeStyles();
    }
  }, {
    key: "hasErrors",
    get: function get() {
      return this.props.errorList.length > 0;
    }
  }, {
    key: "renderErrors",
    value: function renderErrors() {
      var _this = this;
      if (!this.hasErrors) {
        return null;
      }
      var errorMessages = toErrors(this.props.errorList);
      return jsx("div", {
        className: "errorList",
        css: this.props.styles.errorList
      }, enhanceErrorMessages(errorMessages).map(function (_ref, index) {
        var text = _ref.text;
        var originalText = errorMessages[index];
        var key = typeof (originalText === null || originalText === void 0 ? void 0 : originalText.text) === 'string' ? originalText.text : index;
        return jsx("div", {
          className: "error",
          css: _this.props.styles.error,
          key: key
        }, jsx(Text, {
          size: "small",
          color: "danger"
        }, text));
      }));
    }
  }, {
    key: "renderErrorList",
    value: function renderErrorList(errorMessages) {
      var _errorMessages$;
      var useList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return useList ? jsx("ul", null, errorMessages.map(function (_ref2, index) {
        var text = _ref2.text;
        var key = typeof text === 'string' ? text : index;
        return jsx("li", {
          key: key
        }, text);
      })) : (_errorMessages$ = errorMessages[0]) === null || _errorMessages$ === void 0 ? void 0 : _errorMessages$.text;
    }
  }, {
    key: "renderGroupErrors",
    value: function renderGroupErrors() {
      if (!this.hasErrors) return null;
      var errorMessages = toErrors(this.props.errorList);
      var multipleErrors = errorMessages.length > 1;
      var alertProps = _objectSpread({
        variant: 'warning',
        margin: 'small',
        hasShadow: false
      }, multipleErrors && {
        themeOverride: {
          contentPadding: '0'
        }
      });
      return jsx("div", {
        className: "errorList",
        css: this.props.styles.errorList
      }, jsx("div", {
        role: "alert",
        className: "errorAlert",
        css: this.props.styles.errorAlert
      }, jsx(Alert, alertProps, this.renderErrorList(errorMessages, multipleErrors))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        errorsFirst = _this$props.errorsFirst,
        isGroupError = _this$props.isGroupError;
      var errorComponent = isGroupError ? this.renderGroupErrors() : this.renderErrors();
      return jsx("div", {
        css: this.props.styles.errorsContainer
      }, errorsFirst && errorComponent, jsx(View, null, children), !errorsFirst && errorComponent);
    }
  }]);
}(Component), _defineProperty(_Errors, "displayName", 'Errors'), _defineProperty(_Errors, "componentId", "Quizzes".concat(_Errors.displayName)), _defineProperty(_Errors, "propTypes", {
  children: PropTypes.node,
  errorList: PropTypes.array,
  showBorder: PropTypes.bool,
  errorsFirst: PropTypes.bool,
  makeStyles: PropTypes.func,
  styles: PropTypes.object,
  isGroupError: PropTypes.bool
}), _defineProperty(_Errors, "defaultProps", {
  children: void 0,
  errorList: [],
  showBorder: true,
  errorsFirst: true,
  isGroupError: false
}), _Errors)) || _class);
export { Errors as default };